import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Stack, Typography, Button, Modal, Grid, Divider, Paper, Skeleton, Switch, useTheme, useMediaQuery, } from '@mui/material';
import { CategoryService } from './CategoryService';
import AddCategory from './AddCategory';
import { isMobile } from 'react-device-detect';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import { useForm } from 'react-hook-form';
import { Helpers } from '../../services/Helpers';
import { PermissionGuard } from '../../components/PermissionGuard';
import Loading from '../../components/Loader/Loading';
import PageHeaderLayout from '../../components/Layout/PageHeaderLayout';
import Swal from 'sweetalert2';

const style = {
    position: 'absolute',
    top: (isMobile) ? '80%' : '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #ddd',
    boxShadow: 24,
    p: 2,
};


const CategoryTabs = ({ }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const { control, handleSubmit, reset, setValue, getValues, formState: { errors } } = useForm({
        mode: "onChange"
    });

    const [selectedTab, setSelectedTab] = useState();
    const [categories, setCategories] = useState([]);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const [isLoadingSubCategory, setIsLoadingSubCategory] = useState(false);
    const [subCategorylist, setSubCategorylist] = useState([]);

    // on selecting category tab set subCategorylist according to selected category
    useEffect(() => {
        if (categories && categories[selectedTab]) {
            setIsLoadingSubCategory(true);
            setSubCategorylist(categories[selectedTab].childCategories);
            setIsLoadingSubCategory(false);
        }
    }, [selectedTab])


    const [loading, setLoading] = useState(false);
    const [controller, setController] = useState({
        searchKey: "",
        status: "",
    });
    const [deleteCat, setDeleteCat] = useState(0);

    /************************  Modal State Manage **************************** */
    const [open, setOpen] = useState(false);
    const [ids, setIds] = useState({});
    const [catType, setCatType] = useState(1);
    const [populateTable, setPopulateTable] = useState(0);

    /************************ VAriation Modal State Manage **************************** */
    const [openVariation, setOpenVaration] = useState(false);
    const [catData, setCatData] = useState([])

    const getData = async () => {
        try {
            setLoading(true);
            const response = await CategoryService.allCategories({
                searchKey: controller.searchKey,
                status: controller.status
            });
            // console.log("category response:",response)
            setCategories(response.data);
            setSelectedTab(0);
        } catch (error) {
            // console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        getData();
    }, [controller, deleteCat, populateTable])

    /************************  Modal Manage **************************** */
    const modalOpen = (id, catType) => {
        setOpen(true);
        setIds(id);
        setCatType(catType)
    }

    const handleClose = () => {
        setOpen(false);
        setIds(0);
        setOpenVaration(false);
        setCatData([]);
    };
    const afterAddPop = (data) => {
        setPopulateTable(data);
    }

    const handleStatusChange = async (id, currentStatus, type) => {
        console.log("category id:", id);
        let previouslyselectedTab;
        const result = await Swal.fire({ // Await the confirmation
            title: 'Are you sure?',
            text: `You want to ${currentStatus ? 'De-Activate' : 'Activate'} this ${type}!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: `Yes, ${currentStatus ? 'De-Activate' : 'Activate'} it!`,
            allowOutsideClick: false,
        });

        if (result.isConfirmed) {
            previouslyselectedTab = selectedTab;
            Swal.fire({
                title: 'Processing',
                html: 'Please wait...',
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading();
                },
            });

            try {
                const statusModificationResponse = await CategoryService.modifyStatus(id);
                if (statusModificationResponse.success == '1') {
                    getData(); // Refresh table data
                    // setSelectedTab();
                    await Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: `${type} ${currentStatus ? 'De-Activated' : 'Activated'} successfully!`,
                    });
                    setSelectedTab(previouslyselectedTab);
                } else {
                    await Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Something went wrong! Please try again later.',
                    });
                }
            } catch (error) {
                console.error("Error modifying status:", error);
                await Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Something went wrong! Please try again later.',
                });
            }
        }
    };

    return (
        <Box>
            {loading && <Loading />}

            {/*================= Add Category modal ================*/}
            <Box>
                <Modal
                    open={open}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    sx={{ overflow: "scroll",p:0 }}
                >
                    <Box sx={{...style,width:{xs:'95%',md:'30%'},p:0}}>
                        <AddCategory populateList={afterAddPop} closeEvent={handleClose} catType={catType} rowId={ids} />
                    </Box>
                </Modal>
            </Box>
            {/* ======================= Page  title and menu section ================ */}
            <PageHeaderLayout headerTitle={'Manage Categories'}>
                <PermissionGuard feature='category' permission='canCreate'>
                    <Button variant='contained' size='small' onClick={() => modalOpen({}, 1)} 
                        sx={{ fontSize:{xs:'.5rem',sm:'.75rem'} }} 
                        endIcon={<AddCircleIcon sx={{width:{xs:'.75rem'}}}/>}>
                        Category
                    </Button>
                </PermissionGuard>
                <PermissionGuard feature='category' permission='canCreate'>
                    <Button variant='contained' size='small' onClick={() => modalOpen({}, 2)} 
                        sx={{ fontSize:{xs:'.5rem',sm:'.75rem'} }} 
                        endIcon={<AddCircleIcon sx={{width:{xs:'.75rem'}}} />}
                    >
                        Sub Category
                    </Button>
                </PermissionGuard>
            </PageHeaderLayout>

            {/* ========================= Content Section ======================== */}
            <Box sx={{ marginTop: '.5%' }}>
                <Grid container spacing={1}>
                    {/* ========= category tab section ======== */}
                    <Grid item xs={4} sm={3} lg={2}
                        sx={{
                            // display: "flex",
                            // flexDirection: "column",
                            // height: "80vh",
                            // overflow: "auto", // Enable scroll
                            // background: "#fff",
                        }}
                    >
                        <Tabs
                            value={selectedTab}
                            onChange={handleTabChange}
                            indicatorColor="primary"
                            textColor="primary"
                            orientation="vertical" // Set the orientation to 'vertical'
                            variant="scrollable" // Use 'scrollable' variant for longer lists
                            scrollButtons="auto"
                            sx={{ backgroundColor: "#fff" }}
                            align="left"
                        >
                            {categories?.map((category, index) => (
                                <Tab key={index} label={category.title}
                                    sx={{
                                        borderBottom: '1px solid lightGray',
                                        fontSize: '.8rem'
                                    }}
                                />
                            ))}
                        </Tabs>
                    </Grid>
                    <Grid item xs={8} sm={9} lg={10}
                        
                    >
                        <Box sx={{ padding: 1, backgroundColor: "#f9f9f9" }}>
                            <Box>
                                <Stack spacing={1} direction="row" sx={{ justifyContent: 'space-between' }}>
                                    <PermissionGuard feature='category' permission='canEdit'>
                                        <Button
                                            size='small'
                                            //variant='contained' 
                                            onClick={(e) => modalOpen(categories[selectedTab], 1)}
                                            sx={{ textTransform: 'capitalize',fontSize:{xs:'.5rem',md:'.75rem'} ,height:'fit-content'}}
                                            startIcon={<EditIcon sx={{ display: { xs: 'none', sm: 'block' } }} />}
                                            variant="outlined"
                                            color="primary"
                                        >
                                            {"Edit Category"}
                                        </Button>
                                        <Box sx={{ display: { sm: 'flex' }, alignItems: 'center', mr: '1%!impportant' }}>
                                            <Switch
                                                size='small'
                                                checked={categories[selectedTab]?.isActive}
                                                onChange={() => handleStatusChange(categories[selectedTab]?.id, categories[selectedTab]?.isActive, 'Category')}
                                                sx={{
                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                        color: 'success.main',
                                                    },
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                        backgroundColor: 'success.main'
                                                    },
                                                    '& .MuiSwitch-switchBase': {
                                                        color: 'error.main',
                                                    },
                                                    '& .MuiSwitch-track': {
                                                        backgroundColor: 'error.main'
                                                    }
                                                }}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                            />
                                            <Typography
                                                variant="body2"
                                                size="small"
                                                sx={{
                                                    color: (categories[selectedTab]?.isActive) ? 'success.main' : 'error.main',
                                                    fontWeight: '600',
                                                    fontSize: '.65rem',
                                                    display:{xs:'none',sm:'block'}
                                                }}
                                            >
                                                {(categories[selectedTab]?.isActive) ? 'Active' : 'In-Active'}
                                            </Typography>
                                        </Box>
                                    </PermissionGuard>
                                </Stack>
                            </Box>

                            <Divider sx={{ marginTop: 1, marginBottom: 1 }} />

                            <Grid container spacing={1}
                                sx={{
                                    height:{xs:'80vh',sm:'auto'},
                                    overflow:'scroll'
                                }}
                            >
                                {subCategorylist?.map((subcategory, index) => (
                                    <Grid item xs={12} sm={4} md={3} key={index}>
                                        <Paper elevation={1} style={{ padding: 7 }}>
                                            <Grid container spacing={2} >
                                                <Grid item xs={9}>
                                                    <Typography sx={{width:'100%', fontSize: ".65rem", fontWeight: 600, color: '#3e3e3e' }} gutterBottom>
                                                        {subcategory.title}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Stack spacing={0} direction={isSmallScreen ? 'column' : "row"} justifyContent="flex-end" alignItems={'center'}>
                                                        <PermissionGuard feature='category' permission='canEdit'>
                                                            
                                                            <EditIcon
                                                                style={{
                                                                    fontSize: "0.85rem",
                                                                    color: "blue",
                                                                    cursor: "pointer",
                                                                }}
                                                                className="cursor-pointer"
                                                                onClick={(e) => modalOpen(subcategory, 2)}
                                                            />
                                                            <Switch
                                                                size='small'
                                                                checked={subcategory?.isActive}
                                                                onChange={() => handleStatusChange(subcategory?.id, subcategory?.isActive, 'Sub-Category')}
                                                                sx={{
                                                                    // width: {xs:32,sm:40}, // Adjust width
                                                                    // height: {xs:20,sm:24}, // Adjust height
                                                                    // padding: {sm:'7px'},
                                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                                        color: 'success.main',
                                                                    },
                                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                                        backgroundColor: 'success.main'
                                                                    },
                                                                    '& .MuiSwitch-switchBase': {
                                                                        color: 'error.main',
                                                                    },
                                                                    '& .MuiSwitch-track': {
                                                                        backgroundColor: 'error.main'
                                                                    }
                                                                }}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                            />
                                                        </PermissionGuard>
                                                    </Stack>
                                                </Grid>
                                            </Grid>

                                            <Divider sx={{ marginTop: 1, marginBottom: 1 }} />
                                            {subcategory.image &&
                                                <Box>
                                                    {isLoadingSubCategory ?
                                                        <Skeleton variant="rectangular" width={210} height={118} />
                                                        :
                                                        <img
                                                            src={`${Helpers.ImagePathUrl()}/category/${isSmallScreen ? 'sm' : 'md'}/${subcategory.image}`}
                                                            style={{ width: '100%' }}
                                                        />
                                                    }
                                                </Box>
                                            }
                                        </Paper>

                                    </Grid>
                                ))}

                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default CategoryTabs;
